mainApp.directive('ikev2', function() {
    return {
        templateUrl: '/public/directives/ikev2.html',
        scope: {
            ikeProperties : '=?',

        },
        controller:  ['$scope', '$timeout', '$state',"IconsService","GeneralUtilsService","LocationService", function($scope, $timeout, $state,IconsService,GeneralUtilsService,LocationService) {
            $scope.icons = IconsService.getIcons();
            $scope.customIps = [];
            $scope.networkRanges = [];
            $scope.interfacesShowItem ='custom';

            $scope.encryptionOptions = [
                {
                    name: 'Automatic',
                    value: 'AUTOMATIC'
                },
                {
                    name: 'AES CBC 128',
                    value: 'AES_CBC_128'
                },
                {
                    name: 'AES CBC 256',
                    value: 'AES_CBC_256'
                },
                {
                    name: 'AES 128 GCM-16',
                    value: 'AES_GCM_128'
                },
                {
                    name: 'AES 256 GCM-16',
                    value: 'AES_GCM_256'
                }
            ];


            $scope.encryptionAlgorithmsOptions = [
                {
                    name:'Automatic',
                    value: 'AUTOMATIC_ENCR'
                },
                {
                    name: 'AES CBC',
                    value: 'AES_CBC'
                },{
                    name: 'AES 16 GCM-16',
                    value: 'AES_GCM_16'
                }];


            $scope.encryptionAlgorithmLenOptions = [{
                name: 'Automatic',
                value: 'AUTOMATIC_LEN'
            },{
                name: 'AES 128',
                value: 'AES_128'
            },{
                name: 'AES 256',
                value: 'AES_256'
            }];


            $scope.pseudoRandomFunctionAlgorithmOptions = [
                {
                    name:'Automatic',
                    value: 'AUTOMATIC_PRF'
                },{
                    name: 'SHA1',
                    value:'HMAC_SHA1'
                },{
                    name: 'SHA2 256',
                    value: 'HMAC_SHA2_256'

                },{
                    name: 'SHA2 384',
                    value: 'HMAC_SHA2_384'
                }, {
                    name: 'SHA2 512',
                    value: 'HMAC_SHA2_512'
                }
            ];


            $scope.integrityAlgorithmsOptions = [
                {
                    name:'Automatic',
                    value: 'AUTOMATIC_INTEGRITY'
                },{
                    name: 'SHA1',
                    value: 'HMAC_SHA1_96'
                },{
                    name: 'SHA2 256',
                    value: 'HMAC_SHA2_256_128'
                },{
                    name: 'SHA2 384',
                    value:'HMAC_SHA2_384_192'
                },{
                    name: 'SHA2 512',
                    value:'HMAC_SHA2_512_256'
                }];

            $scope.gcmIntegrityAlgorithmsOptions = [
                {
                    name:'Automatic',
                    value: 'AUTOMATIC_INTEGRITY'

                }];

            $scope.initMessageIntegrityAlgorithmsOptions = $scope.integrityAlgorithmsOptions;
            $scope.authMessageIntegrityAlgorithmsOptions = $scope.integrityAlgorithmsOptions;

            $scope.diffieHellmanGroupOptionsPrimary = [
                {
                    name: 'Group 2 (1024)',
                    value: 'GROUP_2_MODP1024'
                },{
                    name: 'Group 5 (1536)',
                    value: 'GROUP_5_MODP1536'
                },{
                    name: 'Group 14 (2048)',
                    value: 'GROUP_14_MODP2048'
                },{
                    name: 'Group 15 (3072)',
                    value: 'GROUP_15_MODP3072'
                },{
                    name: 'Group 16 (4096)',
                    value: 'GROUP_16_MODP4096'
                },{
                    name: 'Group 21 (521)',
                    value: 'GROUP_21_ECP521'
                }];


            $scope.diffieHellmanGroupOptionsSecondary = [{
                name: 'None',
                value: 'GROUP_0_NONE'
            },{
                name: 'Group 2 (1024)',
                value: 'GROUP_2_MODP1024'
            },{
                name: 'Group 5 (1536)',
                value: 'GROUP_5_MODP1536'
            },{
                name: 'Group 14 (2048)',
                value: 'GROUP_14_MODP2048'
            },{
                name: 'Group 15 (3072)',
                value: 'GROUP_15_MODP3072'
            },{
                name: 'Group 16 (4096)',
                value: 'GROUP_16_MODP4096'
            },{
                name: 'Group 21 (521)',
                value: 'GROUP_21_ECP521'
            }
            ];


            $scope.openAddNetworkRangeDlg = function(){
                $scope.interfacesShowItem ='custom';
                $scope.$root.openPopup('addRangeDialog');

            };

            /**
             * this callback weill be invoked when user clicks on the X button near a network range
             * cause to delete the network range
             **/
            $scope.onNetworkRangeRemove = function(){
                if($scope.site && $scope.site.ikeV2){
                    $scope.customIps ="";
                    $scope.networkRanges.forEach(function(networkRange){
                        if(networkRange.display_name){
                            $scope.customIps = $scope.customIps+","  +networkRange.display_name;
                        }
                        else{
                            $scope.customIps = $scope.customIps+","  +networkRange;
                        }
                    });
                    $scope.customIps= $scope.customIps.substring(1,$scope.customIps.length);
                }
                $scope.addNetworkRange();
            };

            /**
             * add network to the custom ranges on the site
             **/
            $scope.addNetworkRange = function(){
                if($scope.site && $scope.site.ikeV2){
                    $scope.networkRanges = [];
                    $scope.site.ikeV2.customRanges = [];
                    if($scope.customIps){
                        var customIpsArr = $scope.customIps.split(",");
                        customIpsArr.forEach(function(customIpStr){
                            // ignore redundant ","
                            if(customIpStr != ""){
                                var customIpTokens = customIpStr.split(":");
                                $scope.networkRanges.push({"id":customIpTokens[1],"display_name":customIpTokens[0] + ":" + customIpTokens[1], "ip":customIpTokens[1]});
                                $scope.site.ikeV2.customRanges.push(customIpStr);
                            }
                        });
                    }
                    $scope.$root.closePopup('addRangeDialog');
                }
            };

            function loadAllocatedIps(onSuccess) {
                if($scope.site){
                    store.fetch({
                        path: "/fetchAllocatedIps?accountId="+$state.params.accountId,
                        queryParams: {
                            accountId: $state.params.accountId
                        },
                        success: function(data) {
                            enrichAllocatedIps(data);
                            $scope.primaryIpForwardingOptions = [];
                            $scope.secondaryIpForwardingOptions =[];

                            data.forEach(function (allocatedIp) {
                                if(ikeV2Defined() && $scope.site.ikeV2.primaryLocalAddress && allocatedIp.id == $scope.site.ikeV2.primaryLocalAddress.id){
                                    $scope.primaryIpForwardingOptions.push($scope.site.ikeV2.primaryLocalAddress);
                                    // we enrich both theoriginal and the site so we won't have changes
                                    enrichSingleAllocatedIp($scope.site.ikeV2.primaryLocalAddress);
                                    enrichSingleAllocatedIp($scope.orig.ikeV2.primaryLocalAddress);
                                }
                                else{
                                    $scope.primaryIpForwardingOptions.push(allocatedIp);
                                }
                                if(ikeV2Defined() && $scope.site.ikeV2.secondaryLocalAddress && allocatedIp.id == $scope.site.ikeV2.secondaryLocalAddress.id){
                                    // we enrich both theoriginal and the site so we won't have changes
                                    enrichSingleAllocatedIp($scope.site.ikeV2.secondaryLocalAddress);
                                    enrichSingleAllocatedIp($scope.orig.ikeV2.secondaryLocalAddress);
                                    $scope.secondaryIpForwardingOptions.push( $scope.site.ikeV2.secondaryLocalAddress);
                                }
                                else{

                                    $scope.secondaryIpForwardingOptions.push(allocatedIp);
                                }
                            });
                            if(onSuccess){
                                onSuccess();
                            }
                        }
                    });
                }
            }

            /**
             * enrichment of the location on the allocated ip
             * @param items
             */
            function enrichAllocatedIps(items) {
                if(items){
                    items.forEach(function (item) {
                        enrichSingleAllocatedIp(item);
                    });
                }
            }


            /**
             * enrichment of the location on a single allocated ip
             * @param allocatedIp
             */
            function enrichSingleAllocatedIp(allocatedIp) {
                if(!allocatedIp.displayName){
                    var locationName = LocationService.getPopLocationViaLocationId($state.params.accountId,allocatedIp.locationId);
                    allocatedIp.displayName = locationName? (locationName.name + ' - '+ allocatedIp.ip): ('Allocated IP - '+ allocatedIp.ip);
                }
            }

            function ikeV2Defined() {
                return $scope.site && $scope.site.ikeV2;

            }

            $scope.openAllocatedIpDialog = function () {
                $scope.$root.openPopup('configureEgress');
            };

            /**
             *  when the directive get a change in this property we will reload the data
             *  meaning changes were made which we would like to revert
             */
            $scope.$watch('ikeProperties.reload', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue) && newValue == true) {
                    if($scope.$parent && $scope.$parent.site){
                        $scope.site = $scope.$parent.site;
                        $scope.orig = $scope.$parent.orig;
                    }
                    else{
                        delete $scope.site;
                        delete $scope.orig;
                    }
                    loadAllocatedIps(function () {
                        $scope.ikeProperties.reload = false;
                        $scope.ikeProperties.showEditPW = false;
                        $scope.ikeProperties.showEditSecPW = false;
                    });
                }
            }, true);


            /**
             *  when the directive get a change in this property we will display the password
             *  since the meaning is that an error is on this property
             */
            $scope.$watch('ikeProperties.showEditPW', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue)) {
                    $scope.showEditPW = newValue;
                }
            }, true);


            $scope.$watch('site.ikeV2.customRanges', function(newValue, oldValue) {
                if (newValue) {
                    if(!_.isEqual(newValue, oldValue)){
                        $scope.networkRanges=[];
                        var ranges = "";
                        $scope.site.ikeV2.customRanges.forEach(function(range){
                            $scope.networkRanges.push(range);
                            ranges = ranges + "," + range;
                        });
                        $scope.customIps = ranges.substring(1,ranges.length);
                    }
                }
                else{
                    $scope.networkRanges =[];
                    $scope.customIps = [];
                }
            }, true);


            /**
             *  when the directive get a change in this property we will display the password
             *  since the meaning is that an error is on this property
             */
            $scope.$watch('ikeProperties.showEditSecPW', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue)) {
                    $scope.showEditSecPW = newValue;
                    $scope.site.secPwShareType = 'CATO_INIT_IPSEC';
                }
            }, true);


            /**
             *  in order to disable the connection status button
             */
            $scope.$watch('site.ikeV2', function(newValue, oldValue) {
                if (newValue) {
                    if(!_.isEqual(newValue, oldValue)){
                        if(!angular.equals($scope.site.ikeV2,$scope.orig.ikeV2)){
                            $scope.ikeV2Changes.value = true;
                        }
                        else{
                            $scope.ikeV2Changes.value = false;
                        }
                    }
                }
            }, true);

            /**
             * ENG-11644
             * Functions which validates that whenever GCM encryption algorithm is chosen the integrity algorithm select
             * has only the AUTOMATIC option. Whenever another algorithm is chosen, the select is filled with the full list of integrity algorithms.
             * @param optionsModel the model of list of algorithms with which the select is filled.
             * @param integrityModel the model which holds the chosen integrity algorithm
             */
            function validateGcmIntegrityOptions(optionsModel, integrityModel) {
                return function (newValue, oldValue) {
                    if (newValue && newValue.indexOf('GCM') !== -1) {
                        $scope[optionsModel] = $scope.gcmIntegrityAlgorithmsOptions;
                        $scope.site.ikeV2[integrityModel] = $scope[optionsModel][0].value;
                    } else {
                        $scope[optionsModel] = $scope.integrityAlgorithmsOptions;
                    }
                };
            }

            $scope.$watch('site.ikeV2.initEncryption', validateGcmIntegrityOptions('initMessageIntegrityAlgorithmsOptions', 'initIntegrityAlgorithm'), true);
            $scope.$watch('site.ikeV2.authEncryption', validateGcmIntegrityOptions('authMessageIntegrityAlgorithmsOptions', 'authIntegrityAlgorithm'), true);

            function init() {
                if($scope.$parent && $scope.$parent.site){
                    $scope.site = $scope.$parent.site;
                    $scope.orig = $scope.$parent.orig;
                }
                else{
                    delete $scope.site;
                }
                $scope.ikeV2Changes ={value:  false};
                loadAllocatedIps()
            }
            init();
        }]
    };
});
